// removed by extract-text-webpack-plugin
module.exports = {"signout_modal":"_2JAV5PqdqAffgJwXyB58FO","content_heading":"_2AClKt2kGT749Oyjycm1Z7","button_loading":"V6CGhyDC83sqeUkLVK2OC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/SignOutModal/SignOutModalComponent.css
// module id = 606
// module chunks = 0